export const salutes: string[] = [
  'dashboard.salutes.haveGreatDay',
  'dashboard.salutes.enjoyYourWork',
  'dashboard.salutes.makeProgress',
  'dashboard.salutes.stayMotivated',
  'dashboard.salutes.keepLearning',
  'dashboard.salutes.seizeTheDay',
  'dashboard.salutes.youGotThis',
  'dashboard.salutes.productiveDay',
  'dashboard.salutes.stayFocused',
  'dashboard.salutes.soarHigh'
];
